import initDropdown from "./helpers/init-dropdown"
import initTableUpdates from "./helpers/init-table-updates"

import "./snow-conditions.scss"
import "./static/watermark.svg"

const CLASS_NAME = "snow-conditions"

function snowConditions() {
  const els = Array.from(document.querySelectorAll(`.${CLASS_NAME}--js`))
  els.forEach((el) => {
    initDropdown(el, CLASS_NAME)
    initTableUpdates(el, CLASS_NAME)
  })
}

export default snowConditions
